import React from 'react';
import styled from 'styled-components';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { menuItems } from '../data';
import { Item } from '../components/Item';

export const MeniItem2 = () => {
    const categoryId = window.location.href.split("/menu/")[1];
    
    let update = [];
    menuItems.forEach(item => {
        if(item.id === categoryId){
            update.push(item);
        }
    });

    const categoryData = update[0];
    
  return (
    <>
    <Navbar />
    <Container>
        <h1 className='menu-header'>{categoryData.name}</h1>
        <div className='drinks'>
            {categoryData.items.map(item => {
                return <Item key={item.id} name={item.name} price={item.price} options={item.options} imgUrl={item.imgUrl} />
            })}
        </div>
        <Footer />
    </Container>
    </>
  )
}

const Container = styled.div`
    background-color: rgba(0,0,0,.8);
    max-width: 1035px;
    margin: auto;
    padding-top: 125px;

    h1.menu-header{
        color: #fff;
        font-family: "Roboto", sans-serif;
        font-size: 1.55rem;
        text-align: center;
        margin-top: 1.5rem;

        i{
            padding-right: 2rem;
        }
    }

    div.drinks{
        padding: 1rem;
        margin: 4rem auto 0 auto;
        display: block;
        max-width: 488px;
    }
`;
